export default "__VITE_ASSET__6CX46wvZ__"